import React from 'react';
import {Link} from "react-router-dom";
import LanguageSwitcher from './LanguageSwitcher';
import Nav from './Nav';
import SearchButton from './SearchButton';

export default class HeaderOne extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <header class="main-header main-header-one clearfix">
                    <div class="main-header-one__wrapper">
                        <div class="main-header-one__top">
                            <div class="container">
                                <div class="main-header-one__top-inner">
                                    <div class="main-header-one__top-address">
                                        <ul>
                                            <li className="d-none">
                                                <div class="icon"><span class="icon-pin"></span></div>
                                                <div class="text"><p>Niku Solutions PTE LTD 133 NEW BRIDGE ROAD #10-03 CHINATOWN POINT, Singapore 521147.</p></div>
                                            </li>

                                            <li className="d-none">
                                                <div class="icon"><span class="icon-clock"></span></div>
                                                <div class="text"><p>Mon-Fri: 08:00 am PST - 05:00 pm PST.</p></div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="main-header-one__top-social-link">
                                        <ul>
                                            <li><a href="#"><i class="icon-facebook-app-symbol"></i></a></li>
                                            <li><a href="#"><i class="icon-pinterest"></i></a></li>
                                            <li><a href="#"><i class="icon-twitter"></i></a></li>
                                            <li><a href="#"><i class="icon-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="main-header-one__bottom">
                            <nav class="main-menu main-menu--1">
                                <div class="main-menu__wrapper">
                                    <div class="container">
                                        <div class="main-menu__wrapper-inner">
                                            <div class="main-header-one__bottom-left">
                                                <div class="logo">
                                                    <Link to={process.env.PUBLIC_URL + `/`}><img src={publicUrl+"assets/images/resources/logobizindex.png"} alt="" /></Link>
                                                </div>
                                            </div>

                                            <div class="main-header-one__bottom-right">
                                                <Nav />

                                                <div class="main-header-one__bottom-right-search">
                                                    <SearchButton />
                                                </div>

                                                {/* <LanguageSwitcher /> */}

                                                {/* <div class="main-header-one__bottom-right-btn">
                                                    <Link to={process.env.PUBLIC_URL + `/`} class="thm-btn">+ Add Listing </Link>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </header>
            </>
        )
    }
}